export default __webpack_public_path__ + "static/bai-cn-728x90-faead4a2ac61ddf6a086a468795d257f.png";